<template>
    <div class="col-sm-12 nopads">
        <div class="col-sm-12 editor-form" @click.stop="">
            <h2 class="editor-header">{{ contractClassUpdate.id && contractClassUpdate.id > 0 ? $t('contracts.contract_class.edit') : $t('contracts.contract_class.add') }}</h2>
            <div class="col-sm-12 form-data nopads">
                <span class="span-title p-2">
                    {{ $t('common.name') }}
                </span>
                <input
                  id="name"
                  v-model="contractClassUpdate.name"
                  required
                  type="text"
                  class="form-control form-control-mb"
                >

                <span class="span-title p-2">
                  {{ $t('api_keys.type') }}
                </span>
                <select
                      id="type"
                      v-model="contractClassUpdate.type"
                      class="form-select form-select-mb"
                      :class="{required_field : contractClassUpdate.type === null}"
                      required
                >
                      <option
                          :value="null"
                          disabled
                      >
                          {{ $t('culvert.select_type') }}
                      </option>
                      <option
                          v-for="option in typeOptions"
                          :key="option.id"
                          :value="option.id"
                      >
                          {{ option.name }}
                      </option>
                </select>

                <span class="span-title px-2 pt-2">
                  {{ $t('common.in_use') }}
                </span>
                <input
                    type="checkbox"
                    class="form-check-input mx-2"
                    v-model="contractClassUpdate.in_use"
                    id="elyContract"
                />

              <!-- Buttons -->
              <div class="col-sm-12 button-container">
                <button
                  class="form-button btn btn-secondary"
                  @click.stop="$emit('close')"
                >
                  {{ $t('common.cancel') }}
                </button>
                <button
                  class="form-button btn btn-success"
                  :disabled="loading"
                  @click.stop="submit()"
                >
                  {{ $t('common.save') }}
                </button>
              </div>
            </div>
        </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
    <base-modal
      v-if="deletion"
      size="sm"
      @ok="deleteContractClass()"
      @close="deletion = false"
    >
      <div class="modal-body">
        <span>{{ $t('common.confirm_delete') }}</span>
      </div>
    </base-modal>
  </div>
</template>

<script>
import {restApi} from '@/components/mixins/RestApiMixin'
import {inject} from "vue";
import BaseModal from "@/components/BaseModal.vue";

export default {
    name: 'ContractClassEditor',
    components: {BaseModal},
    mixins: [restApi],
    props: {
        contractClass: {
            type: Object,
            default: null
        },
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            contractClassUpdate: JSON.parse(JSON.stringify(this.contractClass)),
            contractOptions: [],
            deletion: false,
            contractsSelected: [],
        }
    },
    computed: {
        typeOptions() {
            return [
                {id: 1, name: this.$t('contracts.contract_class.type.cost')},
                {id: 2, name: this.$t('contracts.contract_class.type.investment')}
            ]
        }
    },
    methods: {
        setDefaultValues: function (contractClass) {
            if (!contractClass.name) {
                this.showAlert(this.$t('contracts.contract_class.name_missing'))
                return undefined
            }
            if (!contractClass.type) {
                this.showAlert(this.$t('contracts.contract_class.type_missing'))
                return undefined
            }
            return contractClass
        },

        submit: function () {
            var json = this.setDefaultValues(this.contractClassUpdate)
            if (json !== undefined) {
                this.loading = true
                if(json.id && json.id > 0) {
                    this.restUpdate(this.contractClassUrl, json, this.success, this.fail)
                } else {
                    this.restAdd(this.contractClassUrl, json, this.success, this.fail)
                }
            }
        },

        success: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        }

    }
}
</script>
